import { Injectable } from '@angular/core';

// Service
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable({
  providedIn: 'root'
})
export class EmulationService {
  constructor(private configService: ConfigService,
    private networkService: NetworkService) {
  }

  // To get filter data for emulation
  public getEmulationFilterDDLValues(cropYear) {
    return this.networkService.getRequest(this.configService.getReportFilterUrl() + '?cropYear=' + cropYear);
  }

  public getAttachedAccountList(data: any) {
    return this.networkService.postRequest(this.configService.getAttachedAccountListUrl(), data);
  }

  // To get user id for emulation
  public getUserIdList(account) {
    return this.networkService.getRequest(this.configService.getUserIdListUrl() + '?account=' + account);
  }

  // Set Emulation
  public setEmulation(emulationUserId) {
    return this.networkService.getRequest(this.configService.setEmulationUrl() + '?emulationUserId=' + emulationUserId);
  }

  // Clear Emulation
  public clearEmulation(userId: string, emulationUserId: string) {
    return this.networkService.getRequest(this.configService.clearEmulationUrl() + '?userId=' + userId + '&emulationUserId=' + emulationUserId);
  }

  // get district
  public getDistrictFilter() {
    return this.networkService.getRequest(this.configService.getDistrictFilterUrl());
  }
}
